import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { DialogBaseComponent } from '@platform/components/dialog-base/dialog-base.component';
import { RichTextFormFieldComponent } from '@platform/components/rich-text-form-field/rich-text-form-field.component';
import { TypedDialog } from '@platform/dialog/dialog-v2.service';
import { ButtonCancelComponent } from '@platform/components/buttons/button-cancel.component';
import { ButtonSaveComponent } from '@platform/components/buttons/button-save.component';
import { LoadingService, provideLoadingService } from '@platform/shared/loading.service';
import { CustomerSpaceService } from '@core/customer-space/customer-space.service';
import { catchError, finalize, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoadingSpinnerOverlayComponent } from '@platform/components/loading-spinner-overlay/loading-spinner-overlay.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-edit-terms-page-dialog',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    RichTextFormFieldComponent,
    DialogBaseComponent,
    ButtonCancelComponent,
    ButtonSaveComponent,
    LoadingSpinnerOverlayComponent,
    CommonModule,
  ],
  templateUrl: './edit-terms-page-dialog.component.html',
  styleUrl: './edit-terms-page-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  providers: [provideLoadingService()],
})
export class EditTermsPageDialogComponent implements TypedDialog<EditTermsPageDialogComponent, any, any> {
  dialogRef = inject(MatDialogRef<EditTermsPageDialogComponent, any>);
  data = inject(MAT_DIALOG_DATA);
  form: FormGroup;
  customModules = signal({
    syntax: false,
    toolbar: [
      [
        'bold',
        'underline',
        'italic',
        'link',
        { list: 'bullet' },
        { color: [] },
        { background: [] },
        { font: [] },
        { size: ['small', false, 'large', 'huge'] },
        { align: [] },
      ],
    ],
  });

  constructor(
    private fg: FormBuilder,
    public loadingService: LoadingService,
    private customerSpaceService: CustomerSpaceService,
    private destroyRef: DestroyRef,
  ) {
    this.form = this.fg.group({
      language: this.data.language,
      rawHtml: this.data.rawHtml,
    });
    console.log(this.data);
  }

  submitForm() {
    const { language, rawHtml } = this.form.value;
    this.loadingService
      .showLoadingUntilCompleted(
        this.customerSpaceService.updateTermsPage({
          language,
          rawHtml,
        }),
      )
      .pipe(
        tap((v) => console.log('updated ', v)),
        catchError((err) => {
          console.log(err);
          return err;
        }),
        finalize(() => {
          this.dialogRef.close();
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((value) => console.log(value));
  }

  close() {
    this.dialogRef.close();
  }
}
